import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import DataTable from 'react-data-table-component';
import './CaseTable.scss';
import './RequirementTable.scss';

const useStyles = makeStyles(theme => ({
  colorPrimary: {
    color: theme.palette.primary.main
  }
}));

export default function RequirementTable(props) {

  const classes = useStyles();
  const [showPagination] = useState(true);

  const columns = [
    {
      name: <div>Requirement</div>,
      cell: row => <div className={`req-head ${classes.colorPrimary}`}>{row.requirement}</div>,
      selector: row => row.requirement,
      sortable: true,
      maxWidth: '25%'
    },
    {
      name: <div>Req <br/>Recieved</div>,
      cell: row => <div className="req-head">{row.requirementRecieved ? 'Yes' : 'No'}</div>,
      selector: row => row.requirementRecieved,
      sortable: true,
      maxWidth: '7%'
    },
    {
      name: <div>Details</div>,
      cell: row => <div className="req-head">{row.requiredOfDetail}</div>,
      selector: row => row.requiredOfDetail,
      sortable: true,
      maxWidth: '17%'
    },
    {
      name: <div>Order Date</div>,
      cell: row => <div className="req-head">{row.orderedDateString}</div>,
      selector: row => row.orderedDateString,
      sortable: true,
      maxWidth: '15%'
    },
    {
      name: <div>Code <br/>Description</div>,
      cell: row => <div className="req-head">{row.requirementCodeDescription}</div>,
      selector: row => row.requirementCodeDescription,
      sortable: true,
      maxWidth: '19%',
    }
  ];

  return (
    <React.Fragment>
      <div className="caseTable requirementTable" id="requirement-table">
        <DataTable
          columns={columns}
          data={props.caseRequirements}
          progressComponent={<div className="d-flex justify-content-center p-5"><CircularProgress /></div>}
          pagination={showPagination}
          paginationServer
          paginationDefaultPage={1}
          paginationTotalRows={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 30]}
          persistTableHead
        />
      </div>
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/RequirementTable.js